import { useMemo, useState } from 'react'

const usePagination = (total, initPageSize = 10) => {
  const [pageSize, setPageSize] = useState(initPageSize)
  const [page, setPage] = useState(1)

  const tablePagination = useMemo(
    () => ({
      current: page,
      pageSize,
      total: total,
      onChange: setPage,
      showSizeChanger: true,
      onShowSizeChange: (current, size) => {
        setPageSize(size)
      },
      showTotal: (total, range) => `${range[0]}-${range[1]} из ${total} записей`,
      pageSizeOptions: [5, 10, 20, 50, 100, 200, 300],
    }),
    [total, page, pageSize]
  )

  return [tablePagination, page, pageSize, setPage]
}

export default usePagination
